<script lang="ts">
	import type { Page as PageType } from '$models/Page/Page';
	import CartIcon from '$components/UI/Icons/CartIcon.svelte';
	import { getCartState } from '$lib/state/cart.svelte';

	let { page }: { page: PageType } = $props();

	const cartState = getCartState();

	function handleCartClick() {
		cartState.toggle();
	}
</script>

{#if !cartState.isEmpty()}
	<div id="cart-icon" class="header-action">
		<button type="button" onclick={handleCartClick}>
			<span class="header-action-dot"></span>
			<CartIcon />
			<span class="header-action-text screenreader"
				>{page.layout.translations.buttonLabels.cart}</span
			>
		</button>
	</div>
{/if}
